// Developer mode flag (System → Settings). When ON, dev-only tools appear
// throughout the app (e.g. the Contacts "🧪 +50 Test" generator). Gate every
// such feature behind isDevMode() so they can be cleanly removed/disabled later.
// Default: ON when unset (we're in active development). Flip the default to OFF
// (or remove the dev features) before public launch.
export function isDevMode() {
  try {
    return JSON.parse(localStorage.getItem('ira_settings') || '{}').devMode !== false;
  } catch {
    return true;
  }
}
